export default "__VITE_ASSET__BeTVWR0M__"